import React, { Component } from 'react';


export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

      this.toggleNavbar = this.toggleNavbar.bind(this);
      
      this.state = {
          collapsed: true
        };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render () {
    return (
        <header className="blue single">
            <nav className="navbar navbar-top navbar-fixed-top jqr">
                <div className="navHeaderTop">
                    <div className="container">
                        <div className="navContainer">
                            <div className="navRow">
                                <div className="navCol navLogo">
                                    <div className="siteLogo desktop">
                                        <a className="logoLink" href="https://www.nova.edu/index.html"
                                            target="_parent">
                                            <img alt=" Nova Southeastern University "
                                                src="https://nova.edu/_files/bts/images/brand-2.0/nsuflorida-web-white.svg"
                                                id="siteLogoImg" />
                                        </a>
                                    </div>
                                    <div className="siteLogo mobile">
                                        <a className="logoLink" href="https://www.nova.edu/index.html"
                                            target="_parent">
                                            <img alt=" Nova Southeastern University "
                                                src="https://nova.edu/_files/bts/images/brand-2.0/nsuflorida-web-white.svg"
                                                id="siteLogoMobileImg" />
                                        </a>
                                    </div>
                                </div>
                        
                            </div>
                        </div>
                    </div>
                </div>
          
            </nav>
        </header>
    );
  }
}
